/**
 * Admin booking actions (M10-T07). Currently just the clinical **admit**:
 * confirm a secured booking when the patient is admitted (ADR-0020). Both
 * hospital_admin (own hospital) and amtc_admin may admit.
 */
import { apiFetch } from './client'

export type AdmittedBooking = {
  reference: string
  status: string // 'admitted' on success
}

/** POST /api/v1/admin/bookings/{reference}/admit. Throws `ApiError`
 * (`not_admittable` 409, `forbidden_role` 403, `not_found` 404). */
export async function admitBooking(
  token: string | null,
  reference: string,
): Promise<AdmittedBooking> {
  const body = await apiFetch<{ data: AdmittedBooking }>(
    `/api/v1/admin/bookings/${encodeURIComponent(reference)}/admit`,
    { method: 'POST', token },
  )
  return body.data
}
